import React, { useMemo } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,CartesianGrid
} from 'recharts';
import "./Charts.css";

const COLORS = {
  Diesel: "#9abfef",
  Petrol: "#FFA500",
  CNG: "#92c022",
  "Speed Petrol": "#7a4a9b",
  LPG: "#ae381c",
  Electric: "#389f81"
};

const FuelSlabChart = ({ data = [], visibleFuels = {}, selectedRange }) => {

  const slabCounts = useMemo(() => {
    const slabs = {
      "0-50": {}, "51-100": {}, "101-200": {}, "201-300": {},
      "301-500": {}, "501-1000": {}
    };

    const selectedRoId = localStorage.getItem("selectedRoId");

    data.filter(item => item.ro_id === selectedRoId)
      .forEach((transaction) => {
        const quantity = parseFloat(transaction.quantity);
        const fuelType = transaction.fueltype;

        if (!visibleFuels[fuelType] || isNaN(quantity)) return;

        let slabLabel = '';
        if (quantity <= 50) slabLabel = "0-50";
        else if (quantity <= 100) slabLabel = "51-100";
        else if (quantity <= 200) slabLabel = "101-200";
        else if (quantity <= 300) slabLabel = "201-300";
        else if (quantity <= 500) slabLabel = "301-500";
        else if (quantity <= 1000) slabLabel = "501-1000";

        if (!slabLabel) return;

        if (!slabs[slabLabel][fuelType]) {
          slabs[slabLabel][fuelType] = { count: 0, quantity: 0 };
        }

        slabs[slabLabel][fuelType].count++;
        slabs[slabLabel][fuelType].quantity += quantity;
      });

    return Object.entries(slabs).map(([slab, fuels]) => {
      const flat = { slab };
      Object.keys(visibleFuels).forEach(fuel => {
        if (visibleFuels[fuel]) {
          const values = fuels[fuel] || { count: 0, quantity: 0 };
          flat[fuel] = values.count;
          flat[`${fuel}_quantity`] = values.quantity;
        }
      });
      return flat;
    });
  }, [data, visibleFuels, selectedRange]);

  const CustomTooltip = ({ payload, label }) => {
    if (payload && payload.length) {
      const tooltipContent = payload
        .filter((entry) => visibleFuels[entry.name])
        .map((entry) => {
          const { name, value, payload: entryPayload } = entry;
          const quantity = entryPayload[`${name}_quantity`];

          return (
            <div key={name}>
              <strong>{name}</strong><br />
              Transactions: {value}<br />
              Total Quantity: {quantity?.toFixed(2)} Litre/KG
            </div>
          );
        });

      if (tooltipContent.length === 0) return null;

      return (
        <div className="custom-tooltip">
          <p><strong>{label}</strong></p>
          {tooltipContent}
        </div>
      );
    }
    return null;
  };

  const filteredFuelTypes = Object.keys(COLORS).filter(fuel => {
  if (!visibleFuels[fuel]) return false;
  // ✅ Check if there is at least one slab with a count > 0 for this fuel
  return slabCounts.some(slab => (slab[fuel] ?? 0) > 0);
});


  return (
    <div className="chart-box bar-chart" style={{ width: "75%" }}>
      <h3 style={{color:"#064a52"}}>Transactions per Volume</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={slabCounts} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="slab"
            interval={0}
            angle={-30}
            textAnchor="end"
            height={60}
            type="category"
            tick={{ fontSize: 10 }}
          />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          {filteredFuelTypes.map((fuel) => (
            <Bar
              key={fuel}
              dataKey={fuel}
              stackId="a"
              fill={COLORS[fuel]}
              barSize={25} 
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FuelSlabChart;
